import switchFunc from 'lib/function/switchFunc'
import LineChairWithAirplaneIcon from 'LuxKit/Icons/line/LineChairWithAirplaneIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineCrownIcon from 'LuxKit/Icons/line/LineCrownIcon'
import LineLuxuryEscapesMonogramIcon from 'LuxKit/Icons/line/LineLuxuryEscapesMonogramIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import LinePercentageIcon from 'LuxKit/Icons/line/LinePercentageIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import type { ComponentProps } from 'react'

const getIcon = switchFunc<typeof SvgIcon, App.LoyaltyBenefitType>({
  airport_transfer: LineTaxiIcon,
  esim_package: LineMobileAndroidIcon,
  lounge_pass: LineChairWithAirplaneIcon,
  hotel_upgrade: LineCrownIcon,
  tour_exp_credit: LineCompassIcon,
  discounted_insurance: LineShieldCheckIcon,
  phone_support: LinePhoneIcon,
  family_and_friends_access: LinePercentageIcon,
}, LineLuxuryEscapesMonogramIcon)

interface Props extends ComponentProps<typeof SvgIcon> {
  benefitType: App.LoyaltyBenefitType
}

function LoyaltyBenefitIcon({ benefitType, ...rest }: Props) {
  const Icon = getIcon(benefitType)
  return <Icon {...rest} />
}

export default LoyaltyBenefitIcon
